<template>
  <div class="register">
    <main-header></main-header>

    <div class="login--container">
      <div class="container">
        <div class="login--form-container shadow-card">
          <div class="auth-title">
            <h3>Регистрация</h3>
          </div>

          <div v-if="errorText.length" class="alert alert-sm alert-danger">{{errorText}}</div>

          <ul class="tabs-container">
            <li
                @click="clickTab(item)"
                v-bind:class="{ active: item.isActive }"
                v-for="item in tabs"
                :key="item.id"
            >
              {{ item.name }}
            </li>
          </ul>
          <form @submit.prevent="register">
            <div class="input-block">
              <label for="reg-email">Адрес электронной почты <span class="req">*</span></label>
              <input
                type="text"
                @focus="formError.email = ''"
                @blur="vEmail"
                v-model="email"
                id="reg-email"
              />
              <div class="form-error">{{ formError.email }}</div>
            </div>
            <div class="input-block">
              <label for="reg-name">
                Ваше Ф.И.О <span class="req">*</span>
              </label>
              <input
                @focus="formError.name = ''"
                @blur="vName"
                type="text"
                v-model="name"
                id="reg-name"
              />
              <div class="form-error">{{ formError.name }}</div>
            </div>
            <div v-show="activeTabIndex != 1" class="input-block">
              <label for="reg-name">ИНН <span class="req">*</span></label>
              <input
                  @focus="formError.inn = ''"
                  @blur="vInn"
                  type="text"
                  v-model="userMore.inn"
                  id="reg-inn"
              />
              <div class="form-error">{{ formError.inn }}</div>
            </div>
            <div class="input-block">
              <label for="reg-name">Контактный номер телефона <span class="req">*</span></label>
              <input
                  @focus="formError.phoneNumber = ''"
                  @blur="vPhoneNumber"
                  type="text"
                  v-model="phoneNumber"
                  id="reg-phonenumber"
              />
              <div class="form-error">{{ formError.phoneNumber }}</div>
            </div>
            <div v-show="activeTabIndex == 2" class="input-block">
              <label for="reg-name">Наименование организации <span class="req">*</span></label>
              <input
                  @focus="formError.organizationName = ''"
                  @blur="vOrganizationName"
                  type="text"
                  v-model="userMore.organizationName"
                  id="reg-orgname"
              />
              <div class="form-error">{{ formError.organizationName }}</div>
            </div>
            <div v-show="activeTabIndex == 2" class="input-block">
              <label for="reg-name">Юридический адрес <span class="req">*</span></label>
              <input
                  @focus="formError.address = ''"
                  @blur="vAddress"
                  type="text"
                  v-model="userMore.address"
                  id="reg-address"
              />
              <div class="form-error">{{ formError.address }}</div>
            </div>
            <div class="input-block">
              <label for="reg-password">Пароль <span class="req">*</span></label>
              <input
                @focus="formError.password = ''"
                @blur="vPassword"
                type="password"
                v-model="password"
                id="reg-password"
              />
              <div class="form-error">{{ formError.password }}</div>
            </div>
            <div class="input-block">
              <label for="reg-promocode">Промокод (если имеется)</label>
              <input
                type="text"
                @focus="formError.promocode = ''"
                @blur="vPromocode"
                v-model="promocode"
                id="reg-promocode"
              />
              <div class="form-error">{{ formError.promocode }}</div>
            </div>

            <div class="input-block mrg-t-30">
              <label>
                <input @change="formError.iAgree = ''" type="checkbox" id="reg-licence" v-model="iAgree" />
                Я ознакомился с
                <a href="https://enroller.ru/user-agreement.html" target="_blank" class="cursor-pointer text-link">
                пользовательским соглашением</a> и принимаю его условия
              </label>
              <div class="form-error">{{ formError.iAgree }}</div>
            </div>
            <div class="input-block">
              <label>
                <input @change="formError.iAgreePK = ''" type="checkbox" id="reg-privacy" v-model="iAgreePK">
                Я ознакомился с
                <a href="https://enroller.ru/privacy-policy.html" target="_blank" class="cursor-pointer text-link">
                  политикой в отношении обработки персональных данных
                </a>
              </label>
              <div class="form-error">{{ formError.iAgreePK }}</div>
            </div>
            <div class="input-block">
              <label>
                <input @change="formError.iAgreeNotif = ''" type="checkbox" id="reg-notification" v-model="iAgreeNotif">
                Я согласен на получение сервисных, новостных и информационных уведомлений
              </label>
              <div class="form-error">{{ formError.iAgreeNotif }}</div>
            </div>
            <div class="input-block">
              <button type="submit" class="btn btn-sm btn-success">
                Зарегистрироваться
              </button>
            </div>
          </form>

          <div class="mrg-t-30">
            <hr>
            <div class="mrg-t-20 text-right">
              <router-link class="btn btn-sm btn-info" tag="a" :to="`/login/`">Войти</router-link>
              <router-link class="btn btn-sm btn-outline-info" tag="a" :to="`/forget/`">Забыли пароль?</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <notificator></notificator>
    <main-footer></main-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import MainHeader from "../components/site/MainHeader";
import MainFooter from "../components/site/MainFooter";
import Notificator from "../components/Notificator";
import { mapMutations } from "vuex";
import Validator from "../components/libraries/Validator";

const validator = new Validator();

export default {
  name: "Register",
  components: {
    Notificator,
    MainFooter,
    MainHeader
  },
  data() {
    return {
      email: '',
      name: '',
      phoneNumber: '',
      password: '',
      promocode: '',
      userMore: {
        organizationName: '',
        address: '',
        inn: '',
      },
      iAgree: false,
      iAgreePK: false,
      iAgreeNotif: false,
      formError: {
        email: '',
        name: '',
        phoneNumber: '',
        password: '',
        iAgree: '',
        iAgreePK: '',
        iAgreeNotif: '',
        inn: '',
        organizationName: '',
        address: '',
        promocode: '',
      },
      errorText: "",
      licencePopup: {
        show: false,
        closeButton: "Закрыть"
      },
      tabs: [
        {
          id: 1,
          name: "Физ.лицо",
          isActive: true
        },
        {
          id: 2,
          name: "Юр.лицо",
          isActive: false
        },
      ],
    };
  },
  computed: {
    activeTabIndex() {
      let result = 0;
      this.tabs.forEach(function(item) {
        if (item.isActive) {
          result = item.id;
        }
      });
      return result;
    },
    validateFiz() {
      let errorCount = 0;
      this.vEmail().result == "error" ? errorCount++ : "";
      this.vName().result == "error" ? errorCount++ : "";
      this.vPhoneNumber().result == "error" ? errorCount++ : "";
      this.vPassword().result == "error" ? errorCount++ : "";
      this.vPromocode().result == "error" ? errorCount++ : "";

      return errorCount;
    },
    validateLegal() {
      let errorCount = 0;
      this.vEmail().result == "error" ? errorCount++ : "";
      this.vName().result == "error" ? errorCount++ : "";
      this.vPhoneNumber().result == "error" ? errorCount++ : "";
      this.vPassword().result == "error" ? errorCount++ : "";
      this.vInn().result == "error" ? errorCount++ : "";
      this.vOrganizationName().result == "error" ? errorCount++ : "";
      this.vAddress().result == "error" ? errorCount++ : "";
      this.vPromocode().result == "error" ? errorCount++ : "";

      return errorCount;
    },
  },
  methods: {
    ...mapMutations(["addNotification"]),
    vEmail(){
      let validate = validator.validate([
        {
          fieldName: "Адрес электронной почты",
          value: this.email,
          type: "required",
          length: 250
        },
        {
          fieldName: "Адрес электронной почты",
          value: this.email,
          type: "email",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.email = validate.message)
          : (this.formError.email = "");
      return validate;
    },
    vPromocode(){
      let validate = validator.validate([
        {
          fieldName: "Промокод",
          value: this.email,
          type: "string",
          length: 25
        },
      ]);
      validate.result == "error"
          ? (this.formError.email = validate.message)
          : (this.formError.email = "");
      return validate;
    },
    vName(){
      let validate = validator.validate([
        {
          fieldName: "Ваше Ф.И.О",
          value: this.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.name = validate.message)
          : (this.formError.name = "");
      return validate;
    },
    vPhoneNumber(){
      let validate = validator.validate([
        {
          fieldName: "Контактный номер",
          value: this.phoneNumber,
          type: "required",
          length: 20
        }
      ]);
      validate.result == "error"
          ? (this.formError.phoneNumber = validate.message)
          : (this.formError.phoneNumber = "");
      return validate;
    },
    vPassword(){
      let validate = validator.validate([
        {
          fieldName: "Пароль",
          value: this.password,
          type: "required"
        }
      ]);
      validate.result == "error"
          ? (this.formError.password = validate.message)
          : (this.formError.password = "");
      return validate;
    },
    vInn(){
      let validate = validator.validate([
        {
          fieldName: "ИНН",
          value: this.userMore.inn,
          type: "required"
        }
      ]);
      validate.result == "error"
          ? (this.formError.inn = validate.message)
          : (this.formError.inn = "");
      return validate;
    },
    vOrganizationName(){
      let validate = validator.validate([
        {
          fieldName: "Наименование организации",
          value: this.userMore.organizationName,
          type: "required"
        }
      ]);
      validate.result == "error"
          ? (this.formError.organizationName = validate.message)
          : (this.formError.organizationName = "");
      return validate;
    },
    vAddress(){
      let validate = validator.validate([
        {
          fieldName: "Юридический адрес",
          value: this.userMore.address,
          type: "required"
        }
      ]);
      validate.result == "error"
          ? (this.formError.address = validate.message)
          : (this.formError.address = "");
      return validate;
    },
    clickTab(item) {
      for (let key in this.tabs) {
        if (this.tabs[key].id === item.id) {
          this.tabs[key].isActive = true;
        } else {
          this.tabs[key].isActive = false;
        }
      }
    },
    register() {
      this.clearError();
      
      if(!this.iAgree){
        this.formError.iAgree = 'Вы не приняли условия пользовательского соглашения';
        return false;
      }
      if(!this.iAgreePK){
        this.formError.iAgreePK = 'Пожалуйста, ознакомьтесь с политикой в отношении обработки персональных данных';
        return false;
      }
      if(!this.iAgreeNotif){
        this.formError.iAgreeNotif = 'Вы не приняли соглашение на отправку уведомлений';
        return false;
      }
      if(this.activeTabIndex == 1){
        if (this.validateFiz) {
          return false;
        }
      }else if(this.activeTabIndex == 2){
        if(this.validateLegal){
          return false;
        }
      }
      let email = this.email.trim();
      let name = this.name.trim();
      let phone_number = this.phoneNumber.trim();
      let password = this.password.trim();
      let iAgree = this.iAgree;
      let userContract = this.userMore;
      let promocode = this.promocode;

      localStorage.setItem("confirmEmail", email);

      this.$store.dispatch("startPreloader");

      this.$store
        .dispatch("register", { email, name, phone_number, password, userContract, iAgree, promocode })
        .then(() => {
          localStorage.setItem("newUser", '1');
          this.$store.dispatch("stopPreloader");
          this.$router.push("/thankyou");
        })
        .catch(err => {
          this.errorText = err.message;
          this.$store.dispatch("stopPreloader");
        });
    },
    clearError() {
      this.errorText = "";
    }
  },
  created() {
    if (this.userData) {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped lang="less">
.login--form-container {
  width: 500px;
  margin: 30px auto 60px auto;
  padding-bottom: 35px;
}
.login--container{
  min-height: 65vh;
  margin-bottom: 100px;
}
@media (max-width: 700px) {
  .login--form-container {
    width: 98%;
  }
}
</style>
